module.exports = __webpack_public_path__ + "static/media/adviser.b6c0d378.svg";